import React, { useEffect, useRef } from 'react';
import installNode from '../assets/porfolio/installNode.png';
import spotify from '../assets/porfolio/spotify.jpg';
import movie from '../assets/porfolio/movie.jpg';
import first from '../assets/1.jpg';
import second from '../assets/2.jpg';
import edora from '../assets/edora.png';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { gsap } from 'gsap';
import { useTranslation } from 'react-i18next';

const portfolios = [
	{
		id: 1,
		src: spotify,
		href: 'https://cosmic-kringle-ca0031.netlify.app/',
	},
	{
		id: 2,
		src: movie,
		href: 'https://cerulean-pixie-ca0ac4.netlify.app/',
	},
	{
		id: 3,
		src: edora,
		href: 'https://edora.ua/',
	},
	{
		id: 4,
		src: first,
		href: '#',
	},
	{
		id: 5,
		src: installNode,
		href: 'https://github.com/kokosikbuller/CRUD_node',
	},
	{
		id: 6,
		src: second,
		href: 'https://github.com/kokosikbuller/form',
	},
];

const Portfolio = () => {
	gsap.registerPlugin(ScrollTrigger);
	const refPortfolio = useRef(null);
	const { t } = useTranslation('translation', {
		keyPrefix: 'portfolio',
	});

	useEffect(() => {
		let ctx = gsap.fromTo(
			refPortfolio.current,
			{
				opacity: 0,
				y: 300,
				x: -100,
			},
			{
				opacity: 1,
				y: 0,
				x: 0,
				duration: 1,
				scrollTrigger: {
					trigger: refPortfolio.current,
					start: 'top 70%',
					end: 'top 60%',
				},
			}
		);
		return () => ctx.revert();
	}, []);

	return (
		<div
			name='portfolio'
			className='bg-gradient-to-b from-black to-gray-800 w-full text-white 
			md:h-screen'
		>
			<div
				ref={refPortfolio}
				className='max-w-screen-lg p-4 mx-auto flex flex-col justify-center w-full h-full'
			>
				<div className='pb-8'>
					<p className='text-4xl font-bold inline border-b-4 border-gray-500'>
						{t('title')}
					</p>
					<p className='py-6'>{t('subTitle')}</p>
				</div>

				<div className='grid sm:grid-cols-2 md:grid-cols-3 gap-8 px-12 sm:px-0'>
					{portfolios.map(({ id, src, href }) => (
						<div key={id} className='shadow-md shadow-gray-600 rounded-lg'>
							<img
								src={src}
								alt=''
								className='rounded-md duration-200 min-h-[175px] hover:scale-105'
							/>
							<div className='flex items-center justify-center'>
								<a
									className='text-white bg-gradient-to-b from-cyan-500 to-blue-500 px-4 py-3 my-8
              		mx-auto flex items-center rounded-md'
									href={href}
									target='_blank'
									rel='noreferrer'
								>
									{t('btn')}
								</a>
							</div>
						</div>
					))}
				</div>
			</div>
		</div>
	);
};

export default Portfolio;
